import {Polyfill} from '@aofl/polyfill-service';
import polyfills from '../config/polyfills';

let polyfill = new Polyfill(polyfills);
let ready = polyfill.loadAll();

export {ready};



// WEBPACK FOOTER //
// ./polyfill-service/index.js